const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

function getConfigValue(key) {
  return runtimeConfig[key] ?? process.env[key];
}

function getBaseUrls(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }

  return {};
}

export const appConfig = {
  showBalance: getConfigValue('REACT_APP_SHOW_BALANCE') === 'true',
  showDetail: getConfigValue('REACT_APP_SHOW_DETAIL') === 'true',
  showIconGithub: getConfigValue('REACT_APP_SHOW_ICONGITHUB') === 'true',
  baseUrls: getBaseUrls(getConfigValue('REACT_APP_BASE_URL')),
};
